import SubtitlesProperties, { shouldResetSelectionState } from "./subtitles";

export default SubtitlesProperties
export { shouldResetSelectionState }
